module.exports = __webpack_public_path__ + "img/img-historia-APA.fb6d5f91.svg";